import React, {useState} from "react"
import MetaTags from 'react-meta-tags';
import {
  Container, 
  Card, CardBody,
  CardTitle, CardSubtitle,
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
  Button,
  Modal, ModalHeader, ModalBody, ModalFooter,
  Spinner, 
} from "reactstrap"
import { Link } from "react-router-dom"
import { get } from "../../../helpers/api_helper"
import * as url from "../../../helpers/url_helper"
import moment from "moment";

import BootstrapTable from 'react-bootstrap-table-next';
import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';
import paginationFactory from 'react-bootstrap-table2-paginator';


const Asset = props => {

  const [loading, setLoading] = React.useState(true);
  const [data, setData] = React.useState(null);

  const fetchData = () => {
    setLoading(true);
      console.log('RESP:');
      get(url.GET_ASSET+'/'+props.id).then(response => {
      console.log('RESP', response);
      if(response.status == 200) {
        setData(response.data);
        setLoading(false);
        }
      else {
        setData(null);
        setLoading(false);
      }
    })
    .catch(error => {
      console.log('err:', error);
    });
  };

  React.useEffect(()=>{
    fetchData();
  }, []);


  return (
      <Modal isOpen={props.isOpen} toggle={props.toggle} size="lg" className="" centered>
        <ModalHeader toggle={props.toggle}>{data == null ? 'Property Details' : data.name}</ModalHeader>
        <ModalBody>
            { loading ? 
            <div style={{textAlign: 'center'}}>
                <Spinner color="primary" />
            </div> 
            :
            <div>
                { data == null ? 
                <div className="text-muted">Asset could  not be loaded</div>
                :
                <table className="table table-striped table-hover">
                    <tbody>
                      <tr>
                        <td className="pb-4">Asset Display Name</td>
                        <td className="pb-4">{data.name}</td>
                      </tr>
                      <tr>
                          <td className="pb-4">Asset Code</td>
                          <td className="pb-4">{data.asset_code}</td>
                      </tr>
                      <tr>
                          <td className="pb-4">Property</td>
                          <td className="pb-4">{data.property?.name}</td>
                      </tr>
                      <tr>
                          <td className="pb-4">Block</td>
                          <td className="pb-4">{data.block?.name}</td>
                      </tr>
                      <tr>
                          <td className="pb-4">Floor</td>
                          <td className="pb-4">{data.floor?.name}</td>
                      </tr>
                      <tr>
                          <td className="pb-4">Asset Owner</td>
                          <td className="pb-4">{data.owner}</td>
                      </tr>
                      <tr>
                          <td className="pb-4">Parent Asset Code</td>
                          <td className="pb-4">{data.parent_asset_code}</td>
                      </tr>
                      <tr>
                          <td className="pb-4">Asset Status</td>
                          <td className="pb-4">{data.asset_status}</td>
                      </tr>
                      <tr>
                          <td className="pb-4">Asset Type</td>
                          <td className="pb-4">{data.assettype?.name}</td>
                      </tr>
                      <tr>
                          <td className="pb-4">Critical</td>
                          <td className="pb-4">{data.critical}</td>
                      </tr>
                      <tr>
                          <td className="pb-4">Maintenance Policy</td>
                          <td className="pb-4">{data.maintenance_policy}</td>
                      </tr>
                      <tr>
                          <td className="pb-4">Capacity</td>
                          <td className="pb-4">{data.capacity}</td>
                      </tr>
                      <tr>
                          <td className="pb-4">Measurement Unit</td>
                          <td className="pb-4">{data.measurement_unit}</td>
                      </tr>
                      <tr>
                          <td className="pb-4">Make</td>
                          <td className="pb-4">{data.make}</td>
                      </tr>
                      <tr>
                          <td className="pb-4">Model No</td>
                          <td className="pb-4">{data.model}</td>
                      </tr>
                      <tr>
                          <td className="pb-4">Asset Serial Number</td>
                          <td className="pb-4">{data.asset_serial_number}</td>
                      </tr>
                      <tr>
                          <td className="pb-4">Service Type</td>
                          <td className="pb-4">{data.service_type}</td>
                      </tr>
                      <tr>
                          <td className="pb-4">Category</td>
                          <td className="pb-4">{data.assetcategory?.name}</td>
                      </tr>
                      <tr>
                          <td className="pb-4">Client Asset Code</td>
                          <td className="pb-4">{data.client_asset_code}</td>
                      </tr>
                      <tr>
                          <td className="pb-4">Compass Asset Code</td>
                          <td className="pb-4">{data.compass_alert_code}</td>
                      </tr>
                      <tr>
                          <td className="pb-4">Warranty Applicable</td>
                          <td className="pb-4">{data.warranty_applicable}</td>
                      </tr>
                      <tr>
                          <td className="pb-4">Warranty Valid Date</td>
                          <td className="pb-4">{data.warranty_valid_date}</td>
                      </tr>
                      <tr>
                          <td className="pb-4">Date Of Installation</td>
                          <td className="pb-4">{data.date_of_installation}</td>
                      </tr>
                      <tr>
                          <td className="pb-4">Remarks</td>
                          <td className="pb-4">{data.remarks}</td>
                      </tr>
                      <tr>
                          <td className="pb-4">Date created</td>
                          <td className="pb-4">{moment(data.created_at).format('DD MMM YYYY, hh:mm a')}</td>
                      </tr>


                    </tbody>
                </table>
                }
            </div>
            }
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={props.toggle}>Close</Button>
          
        </ModalFooter>
      </Modal>
  )
}

export default Asset
